import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'system-';

export default {
    path: '/system',
    name: 'system',
    redirect: {
        name: `${pre}system`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'log',
            name: `${pre}log`,
            meta: {
                ...meta,
                title: '日志管理',
                closable: false
            },
            component: () => import('@/pages/system/log/')
        },{
            path: 'dict',
            name: `${pre}dict`,
            meta: {
                ...meta,
                title: '字典管理',
                closable: false
            },
            component: () => import('@/pages/system/dict/dict')
        },{
            path: 'param',
            name: `${pre}param`,
            meta: {
                ...meta,
                title: '参数管理',
                closable: false
            },
            component: () => import('@/pages/system/param')
        },{
            path: 'param/:publicKey',
            name: `${pre}param`,
            meta: {
                ...meta,
                title: '参数管理',
                closable: false
            },
            component: () => import('@/pages/system/public-param')
        },{
            path: 'token',
            name: `${pre}token`,
            meta: {
                ...meta,
                title: '令牌管理',
                closable: false
            },
            component: () => import('@/pages/system/token')
        },{
            path: 'error',
            name: `${pre}error`,
            meta: {
                ...meta,
                title: '异常管理',
                closable: false
            },
            component: () => import('@/pages/system/error')
        },{
            path: 'job',
            name: `${pre}job`,
            meta: {
                ...meta,
                title: '调度管理',
                closable: false
            },
            component: () => import('@/pages/system/job/job')
        },{
            path: 'login-log',
            name: `${pre}login-log`,
            meta: {
                ...meta,
                title: '登录日志',
                closable: false
            },
            component: () => import('@/pages/system/login-log')
        },
    ]
};
